import { type KeyboardEventHandler, type MouseEvent, type Ref } from 'react'
import { NegativeIcon } from '@shipt/design-system-icons'
import { IconButton } from '@shipt/design-system-buttons'
import { type Surface } from '@shipt/design-system-themes'

interface Props {
  onClick: (e: MouseEvent) => void
  className?: string
  surface?: Surface
  iconSize?: 'sm' | 'md' | 'lg'
  ref?: Ref<HTMLButtonElement>
  onKeyDown?: KeyboardEventHandler<HTMLButtonElement>
}

export const CloseButton = ({ surface = 'default', iconSize = 'md', ...restProps }: Props) => (
  <IconButton
    aria-label="Close"
    {...restProps}
    icon={NegativeIcon}
    size={iconSize}
    variant="ghost"
    surface={surface}
  />
)
